import { useRef, useState } from "react";
import { useHistory } from "react-router";
import { connect } from "react-redux";
import moment from "moment-jalaali";
import config from "../../../../utils/config";
import { separateNum } from "../../../../utils";
import { setUser } from "../../../../store/action/auth";
import { cartsChanged } from "../../../../store/action/cart";
import HttpService from "../../../../services/http_service/HttpService";
import Http from "../../../../services/http/Http";
import CartService from "../../../../services/cart/Cart";
import Card from "../../../../components/card";
import { Primary, Warning } from "../../../../components/button";
import Detail from "../Detail";
import logoImg from "../../../../assets/images/64.png";
import {
  Div,
  Container,
  LogoContainer,
  Logo,
  Title,
  ItemData,
  Icon,
} from "./style";

moment.loadPersian({ usePersianDigits: true });

const Item = (props) => {
  let history = useHistory();

  const { user, data, theme, cartsChanged } = props;

  const orderDetailRef = useRef();

  const [loadingSendData, setLoadingSendData] = useState(false);

  const replyOrder = () => {
    setLoadingSendData(true);

    HttpService(user?.token)
      .post("user/orders", {
        order_id: data?.id,
      })
      .then((response) => {
        CartService.setCart(response.data?.entity, cartsChanged);

        Http(response?.status, response?.data?.message, props);

        onChangeRoute("/carts");
      })
      .catch((error) => {
        Http(error?.response?.status, error?.response?.data?.message, props);
      })
      .finally(() => {
        setLoadingSendData(false);
      });
  };

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);
  };

  return (
    <>
      <Detail refrence={orderDetailRef} data={data} />
      <Container>
        <Card className="p-2 py-3 text-right mb-2">
          <Div>
            <LogoContainer className="d-inline-block" theme={theme}>
              <Logo src={logoImg} />
            </LogoContainer>
            <Div className="d-inline-block vertical-align-middle mr-3">
              <Title className="f-15" theme={theme}>
                {config.description}
              </Title>
              <Div className="mt-1">
                <ItemData className="f-12" theme={theme}>
                  <Icon className="fal fa-calendar pl-2" theme={theme}></Icon>
                  {moment(data.created_at, "YYYY-M-D HH:mm:ss").format(
                    "jD jMMMM"
                  )}
                </ItemData>
                <ItemData className="mx-3" theme={theme}>
                  |
                </ItemData>
                <ItemData className="f-12" theme={theme}>
                  <Icon className="fal fa-clock pl-2" theme={theme}></Icon>
                  {moment(data.created_at, "YYYY-M-D HH:mm:ss").format("HH:mm")}
                </ItemData>
              </Div>
              {data.address ? (
                <Div>
                  <ItemData className="f-13" theme={theme}>
                    <Icon
                      className="fal fa-map-marker-alt pl-2"
                      theme={theme}
                    ></Icon>
                    <ItemData theme={theme}>
                      {data.address.slice(0, 30)}
                    </ItemData>
                  </ItemData>
                </Div>
              ) : (
                <Div>
                  <ItemData className="f-13" theme={theme}>
                    <Icon
                      className="fal fa-map-marker-alt pl-2"
                      theme={theme}
                    ></Icon>
                    <ItemData theme={theme}>تحویل حضوری</ItemData>
                  </ItemData>
                </Div>
              )}
            </Div>
          </Div>
          <Div className="mt-3 mx-2">
            <Title className="f-13 d-inline-block" theme={theme}>
              مبلغ پرداختی
            </Title>
            <Title className="f-13 d-inline-block float-left" theme={theme}>
              {separateNum(data.payable)} {config.currency}
            </Title>
          </Div>
          <Div className="mt-3">
            <Primary
              containerClass="d-inline-block w-50 pl-1"
              className="d-block f-12"
              title="سفارش مجدد"
              onClick={() => replyOrder()}
              isLoading={loadingSendData}
              sizeSpinner={17}
            />
            <Warning
              containerClass="d-inline-block w-50 px-1"
              className="d-block f-12"
              title="جزییات"
              onClick={() => orderDetailRef.current.changeStatus()}
            />
          </Div>
        </Card>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth?.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser, cartsChanged })(Item);
